import type { ITreeAncestorCouple } from '../model/ITreeAncestorCouple'
import { drawConnector } from './drawConnector'
import { drawMarriageLabel } from './drawMarriageLabel'
import { drawPerson } from './drawPerson'
import { getTreeAncestorRelationship } from './getTreeAncestorRelationship'
import { type ISubtreeSize, PERSON_HEIGHT, PERSON_WIDTH } from './makeSvgTree'

export function drawTreeAncestorCouple({
	test,
	content,
	tac,
	x,
	y,
}: {
	test: SVGElement
	content: string[]
	tac: ITreeAncestorCouple
	x: number
	y: number
}): ISubtreeSize {
	const size: ISubtreeSize = {
		width: 0,
		height: 0,
		x: x,
	}

	let maleSize: ISubtreeSize = { height: 0, width: 0, x: x }
	if (tac.maleNext) {
		maleSize = drawTreeAncestorCouple({
			test,
			content,
			tac: tac.maleNext,
			x: maleSize.x,
			y: y - PERSON_HEIGHT,
		})
	}
	// if (tac.male) {
	maleSize.width = Math.max(maleSize.width, PERSON_WIDTH)
	// }
	let femaleSize: ISubtreeSize = {
		height: 0,
		width: 0,
		x: x + maleSize.width,
	}
	if (tac.femaleNext) {
		femaleSize = drawTreeAncestorCouple({
			test,
			content,
			tac: tac.femaleNext,
			x: femaleSize.x,
			y: y - PERSON_HEIGHT,
		})
	}
	// if (tac.female) {
	femaleSize.width = Math.max(femaleSize.width, PERSON_WIDTH)
	// }
	// if (tac.male) {
	drawPerson({
		test,
		content,
		person: tac.male,
		imageUrl: tac.maleImage,
		x: maleSize.x,
		y,
		relationship: getTreeAncestorRelationship(tac, true),
	})
	// }
	// if (tac.female) {
	drawPerson({
		test,
		content,
		person: tac.female,
		imageUrl: tac.femaleImage,
		x: femaleSize.x,
		y,
		relationship: getTreeAncestorRelationship(tac, false),
	})
	// }
	// if (tac.male && tac.female) {
	size.x = (maleSize.x + femaleSize.x) / 2
	// } else if (tac.male) {
	// 	size.x = maleSize.x
	// } else if (tac.female) {
	// 	size.x = femaleSize.x
	// }
	size.width = maleSize.width + femaleSize.width
	size.height = Math.max(maleSize.height, femaleSize.height) + PERSON_HEIGHT

	// if (tac.male) {
	drawConnector({
		content,
		x1: maleSize.x,
		y1: y,
		x2: size.x,
		y2: y + PERSON_HEIGHT,
	})
	// }
	// if (tac.female) {
	drawConnector({
		content,
		x1: femaleSize.x,
		y1: y,
		x2: size.x,
		y2: y + PERSON_HEIGHT,
	})
	// }
	if (tac.couple /* && tac.male && tac.female */) {
		const mx = size.x + PERSON_WIDTH / 2
		const my = y + PERSON_HEIGHT
		drawMarriageLabel(test, content, tac.couple, mx, my)
	}
	return size
}
